import RepoDetailsInput from "./RepoDetailsInput";

export default RepoDetailsInput;
